module.exports = __webpack_public_path__ + "static/media/Urban.ed71bdff.png";